import { ReactElement, ReactNode, RefObject, useEffect, useId, useRef, useState } from "react";
import { FreeDrag } from "./FreeDrag";
import Vector2 from "../../../utility/Vector2";

interface SlotDragProps
{
    id ?: string;
    slot ?: string;
    lock ?: boolean;
    children ?: ReactNode;
    targetId ?: string;
    canReachTarget ?: () => boolean;
    onTarget ?: () => void;
    onDropped ?: (r: RefObject<HTMLDivElement>) => void;
}

export function SlotDrag (props : SlotDragProps)
{
    const lock : boolean = props.lock !== undefined ? props.lock : false;
    const id = props.id !== undefined ? props.id : useId();
    const slot = props.slot !== undefined ? props.slot : (id + '-slot');
    const dragRef = useRef<HTMLDivElement>(HTMLDivElement.prototype);
    const [size, setSize] = useState(new Vector2(0, 0));

    useEffect(() => {
        setSize(new Vector2(dragRef.current.offsetWidth, dragRef.current.offsetHeight));
    }, [dragRef.current]);

    return <div 
        id={slot} 
        className='draggable-slot'
        style={{minWidth: size.x, width: size.x, minHeight: size.y, height: size.y}}>
            <FreeDrag
                id={id}
                sourceId={slot}
                stickToSource={lock}
                dragRef={dragRef}
                x={0} y={0}
                targetId={props.targetId}
                onTarget={props.onTarget}
                onDragEnded={props.onDropped}
                canReachTarget={props.canReachTarget}>
                {props.children}
            </FreeDrag>
    </div>
}